﻿import {translation} from "@2d-front-monorepo/core";
import {DialogProvider, ErrorDialog, LoadingDialog} from "@2d-front-monorepo/design-library";
import {JSX, RefObject, useEffect, useMemo, useRef} from "react";
import {Outlet, useNavigate} from "react-router";

// @ts-ignore
import * as logos from "url:../images/logos/*.*";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import Loader from "../components/Loader";
import {userStore} from "../contexts/UserContext";
import {reportError} from "../functions";
import {useGlobalContext} from "../hooks/useGlobalContext";
import {useHttpClient} from "../hooks/useHttpClient";
import {useUser} from "../hooks/useUser";
import {PublicRoutes} from "../routes";

function setScrollbarWidth(mainRef: RefObject<HTMLElement | null>): void {
	const m = mainRef.current;
	if (m == null) {
		return
	}
	const scrollbarWidth = m.offsetWidth - m.clientWidth;
	document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
}

export function MainLayout(): JSX.Element {
	const user = useUser();

	const navigate = useNavigate();
	const mainRef = useRef<HTMLElement>(null);
	const isAuthorized = user.authStatus == "logged-in";

	const data = useMemo(() => {
		const installation = useGlobalContext().installation;
		const logo = logos[installation.slug];
		return {name: installation.name, logo: logo["svg"] ?? logo["png"]};
	}, []);

	async function logout(): Promise<void> {
		try {
			await useHttpClient().authentication.signOff();
			userStore.patchState(x => x.authStatus = "unauthorized");
			navigate(PublicRoutes.welcome);

		} catch (error) {
			reportError(error);
		}
	}

	useEffect(() => {
		if (mainRef.current){
			mainRef.current.scrollTop = 0;
		}
	}, [location.pathname]);

	useEffect(() => {
		const ro = new ResizeObserver(() => setScrollbarWidth(mainRef));
		ro.observe(document.body);
		return () => ro.disconnect();
	}, [mainRef]);

	return (<DialogProvider>
		<header>
			<button type="button" popoverTarget="navigation-menu" className="material-symbols-rounded"
			        hidden={!isAuthorized}
			        aria-label="menu" aria-haspopup="menu" aria-controls="navigation-menu"
			        id="menu-button">menu
			</button>

			<a href="/"><img src={data.logo} alt={data.name} height="64"/></a>

			<span id="logout-button" hidden={!isAuthorized}>
				<button type="button" className="form__button form__button--small" onClick={logout}>
					{translation(PermitTranslations.log_out)}
				</button>
			</span>

		</header>
		<main ref={mainRef}><Outlet/></main>
		<ErrorDialog/>
		<LoadingDialog><Loader/></LoadingDialog>
	</DialogProvider>);
}
